// 租户相关展示辅助（角色中文标签等）
export const roleLabel = (role: string) =>
  role === 'owner' ? '拥有者' : role === 'admin' ? '管理员' : '成员';
